import axios from 'axios';

// Константа для базового URL API
const API_URL = process.env.VUE_APP_API_URL;

// Виджет загрузки чеков APMCheck (скрипт qr.apmcheck.ru, см. qrWidget.init): в запрос уходит заголовок api-key = apiKey.
// По умолчанию в apiKey — UUID «API» из кабинета; UUID «Виджет» дублируется в env для тех же значений на dev/prod.
export const APMCHECK_API_KEY =
  process.env.VUE_APP_APMCHECK_API_KEY || '3fc994a2-24da-4207-adea-8de675f8fe5e';
export const APMCHECK_WIDGET_ID =
  process.env.VUE_APP_APMCHECK_WIDGET_ID || '61d597b2-6229-4534-92f6-7be65ebf4065';
export const APMCHECK_API_URL =
  process.env.VUE_APP_APMCHECK_API_URL || 'https://api.apmcheck.ru';

// Функция для установки токена в заголовок Authorization
export const setAuthHeader = () => {
    const token = getToken();
    if (token) {
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
};

// Добавляем интерцептор для обработки ответов
axios.interceptors.response.use(
  response => response,
  error => {
      if (error.response && error.response.status === 401) {
          removeToken();
          delete axios.defaults.headers.common['Authorization'];
      }
      return Promise.reject(error);
  }
);

/** Список периодов акции (Swagger: GET /api/quiz/periods, без query-параметров). */
export async function fetchQuizPeriods() {
    const response = await fetch(`${API_URL}/api/quiz/periods`);
    if (!response.ok) throw new Error('Ошибка загрузки данных');
    return await response.json();
}

/**
 * Список периодов, в которых уже есть победители (Swagger: GET /api/quiz/periods-with-winnings).
 * Доп. фильтр month: february | mart
 */
export async function fetchWinningPeriods({ limit = 10, offset = 0, search = '', month = '' }) {
    const params = new URLSearchParams({ limit, offset });
    if (search) params.append('search', search);
    if (month) params.append('month', month);

    const response = await fetch(`${API_URL}/api/quiz/periods-with-winnings?${params.toString()}`);
    if (!response.ok) throw new Error('Ошибка загрузки данных');
    return await response.json();
}

/**
 * GET /api/quiz/winnings — фильтр типа приза в query: **prize_type** (например weekly, grand, special).
 * @param {{ limit?: number, offset?: number, prize_type?: string, type?: string, user_email?: string, period?: number|null, search?: string }} opts
 * `type` оставлен как алиас к `prize_type` для совместимости вызовов.
 */
export async function fetchWinnings({ limit = 10, offset = 0, prize_type = '', type = '', user_email = '', period = null, search = '' }) {
    const params = new URLSearchParams({ limit, offset });
    const prizeTypeFilter = (prize_type || type || '').trim();
    if (prizeTypeFilter) {
        params.append('prize_type', prizeTypeFilter);
    }
    if (user_email) params.append('user_email', user_email);
    if (search) params.append('search', search);
    // Swagger: period — integer (id периода); 0 — валидное значение, не смешивать с «не задано»
    if (period !== null && period !== undefined && period !== '') {
        const n = Number(period);
        if (Number.isFinite(n)) {
            params.append('period', String(Math.trunc(n)));
        }
    }

    const response = await fetch(`${API_URL}/api/quiz/winnings?${params.toString()}`);
    if (!response.ok) throw new Error('Ошибка загрузки данных');
    return await response.json();
}

// Функция для выполнения запроса на получение чеков пользователя
export const getUserChecks = async (offset, limit) => {
    try {
        setAuthHeader();
        const response = await axios.get(`${API_URL}/api/quiz/user/receipts?offset=${offset}&limit=${limit}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching winning prizes', error);
        throw error;
    }
};

// Функции для работы с токенами, пользователем, настройками и т.д. остаются такими же, как у вас в текущем файле запросов
export const getToken = () => localStorage.getItem('token');

export const setToken = (token) => localStorage.setItem('token', token);

export const removeToken = () => localStorage.removeItem('token');

export const getUserInfo = async () => {
    try {
        setAuthHeader();
        const response = await axios.get(`${API_URL}/api/users/me`);
        return response.data;
    } catch (error) {
        console.error('Error fetching user info', error);
        throw error;
    }
};

export const authorize = async (email, password, token) => {
    try {
        if (localStorage.getItem('tokenGame')) {
            token = localStorage.getItem('tokenGame');
        }

        const response = await axios.post(`${API_URL}/api/users/authorization`, {
            email,
            password,
            token
        });
        setToken(response.data.access);
        setAuthHeader();
        return response.data;
    } catch (error) {
        console.error('Ошибка во время авторизации', error);
        throw error;
    }
};


export const register = async (...args) => {
    try {
        let payload = {};
        // Backward-compatible: support legacy positional arguments and new object form.
        if (args.length === 1 && args[0] && typeof args[0] === 'object' && !Array.isArray(args[0])) {
            payload = { ...args[0] };
        } else {
            const [first_name, last_name, phone_number, email, registration_params, agree_to_advertising, is_policy, is_rules, gender] = args;
            payload = {
                first_name,
                last_name,
                phone_number,
                email,
                registration_params,
                agree_to_advertising,
                is_policy,
                is_rules,
                gender
            };
        }

        const {
            first_name,
            last_name,
            phone_number,
            email,
            registration_params,
            agree_to_advertising,
            is_policy,
            is_rules,
            gender
        } = payload;

        // registration_params должен быть строкой согласно документации API
        let paramsString = '';
        if (registration_params) {
            if (typeof registration_params === 'string') {
                paramsString = registration_params;
            } else if (typeof registration_params === 'object') {
                // Если передан объект, преобразуем в строку
                paramsString = JSON.stringify(registration_params);
            }
        }
        
        const requestData = {
            first_name,
            phone_number,
            email,
            is_policy: is_policy === true || is_policy === 'true', // Обязательное поле
            is_rules: is_rules === true || is_rules === 'true', // Обязательное поле
        };

        if (typeof last_name === 'string' && last_name.trim() !== '') {
            requestData.last_name = last_name;
        }

        if (paramsString) {
            requestData.registration_params = paramsString; // Строка согласно документации API
        }

        requestData.agree_to_advertising = agree_to_advertising === true || agree_to_advertising === 'true';

        if (typeof gender === 'string' && gender.trim() !== '') {
            requestData.gender = gender;
        }
        
        const response = await axios.post(`${API_URL}/api/users/registration`, requestData);
        return response.data;
    } catch (error) {
        // Улучшенная обработка ошибок для отладки
        if (error.response) {
            console.error('Error during registration:', {
                status: error.response.status,
                data: error.response.data,
                message: error.response.data?.detail || error.response.data?.message || 'Unknown error'
            });
        } else {
            console.error('Error during registration', error);
        }
        throw error;
    }
};

/** Обновление профиля (ЛК): PUT /api/users/me — first_name, last_name, phone_number (см. OpenAPI). */
export const changeProfile = async (first_name, last_name, phone_number) => {
    try {
        setAuthHeader();
        await axios.put(`${API_URL}/api/users/me`, {
            first_name,
            last_name,
            phone_number,
        });
    } catch (error) {
        console.error('Error during profile update', error);
        throw error;
    }
};

/**
 * Список игр «Правильный плов» (GET /api/quiz/won-rice).
 * Ответ может быть массивом или объектом с `results` / `data` и метаданными цепочки казанов
 * (`chain_access` и др. — см. `parseWonRiceGamesResponse` в `@/utils/wonRiceNormalize`).
 */
export const fetchWonRiceGames = async () => {
    try {
        setAuthHeader();
        const response = await axios.get(`${API_URL}/api/quiz/won-rice`);
        return response.data;
    } catch (error) {
        console.error('Error fetching won-rice games', error);
        throw error;
    }
};

/**
 * Начало игровой сессии плова: POST /api/game/start.
 * На тестовом API встречаются 400 из‑за формата тела; перебираем несколько валидных для DRF вариантов.
 * @param {Record<string, unknown>|null|undefined} riceGameRow — сырая строка из GET /api/quiz/won-rice
 * @param {number|null|undefined} slotIndex — индекс казана во фронте 0..5; в запрос уходит номер слота **1..6** (`?slot=`, `slot_index`).
 */
export const startGameSession = async (riceGameRow = null, slotIndex = null) => {
    setAuthHeader();
    const base = `${API_URL}/api/game/start`;
    const id =
        riceGameRow && typeof riceGameRow === 'object'
            ? riceGameRow.id ?? riceGameRow.pk
            : null;
    const quizFk =
        riceGameRow && typeof riceGameRow === 'object'
            ? riceGameRow.quiz_id ??
              (riceGameRow.quiz && typeof riceGameRow.quiz === 'object'
                  ? riceGameRow.quiz.id
                  : riceGameRow.quiz)
            : null;

    /** Пары [URL, JSON body] — сначала «пустой» JSON (часто нужен для DRF), затем варианты с id/slot. */
    const attempts = [];
    attempts.push([base, {}]);
    if (Number.isInteger(slotIndex) && slotIndex >= 0 && slotIndex <= 5) {
        const slotOneBased = slotIndex + 1;
        attempts.push([`${base}?slot=${slotOneBased}`, {}]);
        attempts.push([`${base}?rice_slot=${slotOneBased}`, {}]);
        attempts.push([base, { slot_index: slotOneBased }]);
    }
    if (id != null && id !== '') {
        attempts.push([base, { id }]);
        attempts.push([base, { quiz: id }]);
    }
    if (quizFk != null && quizFk !== '' && String(quizFk) !== String(id ?? '')) {
        attempts.push([base, { quiz: quizFk }]);
    }

    const seen = new Set();
    let lastError;
    for (const [url, body] of attempts) {
        const key = `${url}::${JSON.stringify(body)}`;
        if (seen.has(key)) continue;
        seen.add(key);
        try {
            const response = await axios.post(url, body);
            return response.data;
        } catch (e) {
            lastError = e;
            const st = e?.response?.status;
            if (st !== 400) throw e;
        }
    }
    throw lastError;
};

/** Завершение раунда / игры (PATCH /api/game/final_round, без тела). Ответ 206 + JSON с receipt, title и т.д. */
export const completeGameFinalRound = async () => {
    setAuthHeader();
    const response = await axios.patch(`${API_URL}/api/game/final_round`);
    return response.data;
};

export const createUserAddress = async (payload) => {
    try {
        setAuthHeader();
        const response = await axios.post(`${API_URL}/api/users/address`, payload);
        return response.data;
    } catch (error) {
        console.error('Error during create user address', error);
        throw error;
    }
};

/**
 * Смена пароля (PATCH /api/users/change-password).
 * Тело: `{ new_password }`. Успех 200 — в ответе может быть `{ message: string[] }`.
 * Ошибка 554 — пользователь не найден (см. `getErrorMessage` в `@/utils/apiErrors`).
 */
export const changePassword = async (new_password) => {
    try {
        const response = await axios.patch(`${API_URL}/api/users/change-password`, {
            new_password,
        });
        return response.data;
    } catch (error) {
        console.error('Error during change password', error);
        throw error;
    }
};

export const getMainSettings = async () => {
    try {
        const response = await axios.get(`${API_URL}/api/main/settings`);
        return response.data;
    } catch (error) {
        console.error('Error fetching main settings', error);
        throw error;
    }
};

export const fetchFAQ = async () => {
    const endpoint = `${API_URL}/api/feedback/faq?limit=80`;
    try {
        const response = await axios.get(endpoint);
        return response.data;
    } catch (error) {
        console.error("Error fetching FAQ:", error);
        throw error;
    }
};

/** Карточки риса для блока «Продукты» (GET /api/content/rice/). */
export const fetchRiceProducts = async () => {
    try {
        const response = await axios.get(`${API_URL}/api/content/rice/`);
        return response.data;
    } catch (error) {
        console.error('Error fetching rice products', error);
        throw error;
    }
};

/** Магазины для блока «Где купить» (GET /api/content/shops/). */
export const fetchShops = async () => {
    try {
        const response = await axios.get(`${API_URL}/api/content/shops/`);
        return response.data;
    } catch (error) {
        console.error('Error fetching shops', error);
        throw error;
    }
};

/**
 * Текст ошибки для попапов: префикс «! » (макет) и первая буква сообщения — заглавная.
 * Ведущий «!» убирается и задаётся заново, чтобы нормализовать «!ошибка» / «! ошибка».
 * @param {unknown} text
 * @returns {string}
 */
export function prefixPopupServerErrorMessage(text) {
    let body = String(text ?? '').trim();
    if (!body) return '';
    body = body.replace(/^!\s*/, '');
    if (!body) return '!';

    const letterRe = /[A-Za-zА-ЯЁа-яё]/;
    const chars = [...body];
    const idx = chars.findIndex((ch) => letterRe.test(ch));
    if (idx !== -1) {
        chars[idx] = chars[idx].toLocaleUpperCase('ru-RU');
    }
    body = chars.join('');
    return `! ${body}`;
}

/**
 * Текст ошибки из тела ответа API для показа пользователю (без префиксов вроде first_name:).
 * DRF: detail, message, non_field_errors, ошибки по полям.
 */
export function formatApiErrorResponseMessage(data, fallback = 'Произошла ошибка') {
    if (!data) return fallback;
    if (typeof data === 'string') return data;
    if (typeof data.detail === 'string') return data.detail;
    if (Array.isArray(data.detail)) {
        return data.detail
            .map((x) => (typeof x === 'string' ? x : (x && (x.msg || x.message)) || JSON.stringify(x)))
            .join(' ');
    }
    if (Array.isArray(data.message)) return data.message.join(' ');
    if (typeof data.message === 'string') return data.message;
    if (data.non_field_errors) {
        return Array.isArray(data.non_field_errors)
            ? data.non_field_errors.join(', ')
            : String(data.non_field_errors);
    }
    const parts = [];
    Object.keys(data).forEach((k) => {
        if (k === 'detail' || k === 'message' || k === 'non_field_errors') return;
        const v = data[k];
        if (Array.isArray(v)) {
            parts.push(
                v
                    .map((item) =>
                        typeof item === 'string'
                            ? item
                            : (item && (item.msg || item.message)) || JSON.stringify(item)
                    )
                    .join(', ')
            );
        } else if (typeof v === 'string') {
            parts.push(v);
        }
    });
    return parts.length ? parts.join(' ') : fallback;
}

/** Разбор текста ошибки из ответа API (DRF: detail, поля, message). */
export const formatFeedbackSendError = (data) =>
    formatApiErrorResponseMessage(data, 'Не удалось отправить обращение');

export const sendFeedback = async (message) => {
    const endpoint = `${API_URL}/api/feedback/send`;
    const formData = new FormData();

    // Добавляем обычные поля (тело: text + topic / topic_id по контракту бэкенда)
    formData.append('email', message.email);
    formData.append('name', message.name);
    formData.append('text', message.text);
    const topicId = message.subject != null && message.subject !== '' ? Number(message.subject) : 0;
    const topicStr = Number.isFinite(topicId) ? String(Math.trunc(topicId)) : '0';
    formData.append('topic', topicStr);
    formData.append('topic_id', topicStr);

    const agreePd = message.agree_personal_data === true;
    formData.append('agreement', agreePd ? 'true' : 'false');
    formData.append('is_policy', agreePd ? 'true' : 'false');
    formData.append('agree_to_advertising', message.agree_to_advertising === true ? 'true' : 'false');

    // Добавляем файлы, если они есть
    if (message.files && message.files.length > 0) {
        message.files.forEach((file) => {
            // Типы как в ответе API при ошибке вложений
            const allowedTypes = [
                'image/jpeg', 'image/png', 'image/gif', 'image/tiff', 'image/webp',
                'image/heic', 'image/heif', 'image/avif',
                'application/pdf',
            ];
            if (!allowedTypes.includes(file.type)) {
                console.error('Invalid file type:', file.type);
                return;
            }
            // Добавляем файл в FormData
            formData.append('files', file, file.name);
        });
    }

    try {
        const response = await axios.post(endpoint, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error sending feedback:', error.response);
        throw error;
    }
};

export const sendResetPassword = async (email) => {
    const endpoint = `${API_URL}/api/users/recovery-password`;
    const formData = new FormData();

    formData.append('email', email.email);

    try {
        const response = await axios.post(endpoint, formData);
        return response.data;
    } catch (error) {
        console.error('Error sending feedback:', error.response);
        throw error;
    }
};

/**
 * GET /api/feedback/topics — список тем обратной связи (пагинация: count, next, previous, results).
 * @param {{ limit?: number, offset?: number, title?: string }} [params]
 * @returns {Promise<{ count?: number, next?: string|null, previous?: string|null, results?: Array<{id: number, title: string}> }>}
 */
export const fetchFeedbackTopicsPage = async (params = {}) => {
    const limit = params.limit != null ? params.limit : 100;
    const offset = params.offset != null ? params.offset : 0;
    const query = { limit, offset };
    if (params.title != null && String(params.title).trim() !== '') {
        query.title = String(params.title).trim();
    }
    try {
        const response = await axios.get(`${API_URL}/api/feedback/topics`, { params: query });
        return response.data || {};
    } catch (error) {
        console.error('Ошибка загрузки тем обратной связи:', error);
        throw error;
    }
};

/** @returns {Promise<Array<{ id: number, title: string }>>} */
export const fetchTopics = async (limit = 10, offset = 0, title) => {
    const data = await fetchFeedbackTopicsPage({ limit, offset, title });
    return data.results ?? [];
};

/**
 * Темы для выпадающего списка в форме обратной связи (одна страница, по умолчанию до 200 записей).
 * @param {{ limit?: number, offset?: number, title?: string }} [opts]
 */
export const getFeedbackTopics = async (opts = {}) => {
    const data = await fetchFeedbackTopicsPage({
        limit: opts.limit != null ? opts.limit : 200,
        offset: opts.offset != null ? opts.offset : 0,
        title: opts.title,
    });
    return data.results ?? [];
};

export const fetchWinningPrizes = async () => {
    const endpoint = `${API_URL}/api/quiz/user/prizes?limit=100`;
    try {
        const response = await axios.get(endpoint);
        return response.data;
    } catch (error) {
        console.error("Error fetching winning prizes:", error);
        throw error;
    }
};

export const fetchAvailablePrizes = async () => {
    const endpoint = `${API_URL}/api/quiz/prizes?type=guaranteed&limit=100`;
    try {
        const response = await axios.get(endpoint);
        return response.data;
    } catch (error) {
        console.error("Error fetching available prizes:", error);
        throw error;
    }
};

export const fetchAdditionalPrizeFile = async (additionalDataId) => {
    const endpoint = `${API_URL}/api/quiz/user/prizes/additional-data/${additionalDataId}`;
    try {
        const response = await axios.get(endpoint, {
            responseType: 'blob',
        });
        return response;
    } catch (error) {
        console.error("Error fetching additional prize file:", error);
        throw error;
    }
};

export const getPrizes = async (params = {}) => {
    try {
        const response = await axios.get(`${API_URL}/api/quiz/prizes`, { params });
        return response.data;
    } catch (error) {
        console.error('Error fetching prizes:', error);
        throw error;
    }
};
// export const fetchGoods = async (limit = 6, offset = 0) => {
//     try {
//         const response = await axios.get(`${API_URL}/api/goods`, {
//             params: { limit, offset }
//         });
//         return response.data;
//     } catch (error) {
//         console.error('Error fetching goods:', error);
//         return null;
//     }
// };







export default {
    getToken,
    setToken,
    removeToken,
    getUserInfo,
    authorize,
    register,
    getMainSettings,
    fetchFAQ,
    sendFeedback,
    sendResetPassword,
    fetchTopics,
    fetchWinningPrizes,
    fetchAvailablePrizes,
    fetchAdditionalPrizeFile,
    fetchWinnings,
    fetchQuizPeriods,
    fetchWinningPeriods,
    fetchWonRiceGames,
    startGameSession,
    completeGameFinalRound,
    changeProfile,
};
